export default __webpack_public_path__ + "static/media/cripple3.c8468e5b.png";